import { render, staticRenderFns } from "./Prompts.vue?vue&type=template&id=2b3a9cee"
import script from "./Prompts.vue?vue&type=script&lang=js"
export * from "./Prompts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports